export const identity = <T>(o: T): T => o;
